// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3s9M6","text":"SelectPayment_text__1JOE7","title":"SelectPayment_title__3QakA","btn":"SelectPayment_btn__2yRrS"};